<template>
    <div class="seat-selection-wrapper">
        <!-- top返回 -->
      <MovieGoBack :text="text"></MovieGoBack>

      <div class="movie-box seat-selection-content">
          <!-- 卡片 -->
          <div class="movie-box acea-row movie-detail-card">
            <img src="https://img.daeyes.com.cn:8081/uploads/images/Film/4377fab5-f81d-42ec-b001-73135da9dd33/20210208090807.jpg"/>
            <div class="page-text-ellipsis-nowrap detail">
                <div class="h">你好，李焕英</div>
                <p>奇幻/动作/冒险</p>
                <p>英语3D</p>
                <p>今天3月25日 18：15~20：15</p>
            </div>
          </div>
          <div class="seat-selection">

          </div>

      </div>

        <!-- 确认选座 -->
      <MovieBottomButton :text="confirm"  :goTo="{path:'/confirmOrder'}"></MovieBottomButton>
    </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";
import MovieBottomButton from "@components/MovieBottomButton.vue";

export default {
    name:"SeatSelection",
    data:function(){
        return {
            text:"劲松电影院",
            confirm:"确认选座"
        }
    },
    components:{
        MovieGoBack,
        MovieBottomButton
    }
}
</script>

<style scoped>
.seat-selection{
    height:6.5rem;
    background:rgb(0, 140, 255);
}
.seat-selection-content{
    padding:0 .3rem;
}

.movie-detail-card{
    margin:.3rem 0;
}

.movie-detail-card img{
    width:1.91rem;
    height:2.37rem;
    box-shadow: 0px 4px 9px 0px rgba(255, 12, 70, 0.29);
    border-radius:.15rem;
    flex-shrink: 0;
}
.detail{
    flex:1;
    margin-left:.34rem;
    overflow:hidden;
}
.detail .h{
    width:100%;
    font-size:.4rem;
    font-weight: 500;
    color: #333333;
    line-height: .8rem;
}
.detail p{
    font-size:.27rem;
    color: #666666;
    margin-bottom:.08rem;
}

</style>